import { X } from 'lucide-react';

const Modal = ({ show, onClose, title, children, testId }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid={testId}>
      <div className="bg-white rounded-lg p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-[#1A2620] font-['Manrope']">{title}</h2>
          <button onClick={onClose} type="button"><X className="w-5 h-5 text-[#5C6B63]" /></button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
